// @flow
import React, { Component } from 'react';
import classNames from 'classnames';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import Link from '@liveauctioneers/caterwaul-components4/lib/Link/Link';
import styles from './Notification.module.scss';

type Props = {
    id: number,
    imageUrl: string,
    isNew: boolean,
    link: string,
    markNotificationsDeleted: Function,
    markNotificationsRead: Function,
    message: string,
    messageLevel: string,
    timestamp: string,
    title: string,
};

type State = {
    isHovered: boolean,
};

export default class Notification extends Component<Props, State> {
    static defaultProps = {
        id: 0,
        imageUrl: '',
        isNew: false,
        link: '',
        message: '',
        messageLevel: '',
        timestamp: '',
        title: '',
    };
    state = { isHovered: false };

    markDeleted = () => {
        this.props.markNotificationsDeleted([this.props.id]);
    };

    markDeletedWithoutNavigation = (event: any) => {
        event.preventDefault();
        this.props.markNotificationsDeleted([this.props.id]);
    };

    markRead = () => {
        this.props.markNotificationsRead([this.props.id]);
    };

    markReadWithoutNavigation = (event: any) => {
        event.preventDefault();
        this.props.markNotificationsRead([this.props.id]);
    };

    hover = () => {
        this.setState({ isHovered: true });
    };

    leave = () => {
        this.setState({ isHovered: false });
    };

    render() {
        let { title } = this.props;
        const { imageUrl, isNew, link, message, messageLevel, timestamp } = this.props;
        const notificationClasses = classNames([styles.notification, isNew && styles.isNew]);
        const timestampClasses = classNames([styles.timestamp, isNew && styles.newness]);
        const titleClassnames = classNames([styles.title, messageLevel === 'urgent' && styles.urgent]);
        const target = link.toLowerCase().includes('console') ? '_blank' : '_self';
        const route = link.toLowerCase().includes('item') || link.toLowerCase().includes('catalog');
        const newLabel = isNew ? (
            <>
                <span className={styles.newDot}>{'\u2022'}</span>
                <span>New |&nbsp;</span>
            </>
        ) : null;

        const timestampDisplay = timestamp.match(/less than a minute/) ? (
            <FormattedMessage id="notifications.just_now" />
        ) : (
            timestamp
        );
        const approvedMatch = title.match(/Approved by (.*)/i);
        const declinedMatch = title.match(/Declined by (.*)/i);
        let houseName;
        if (approvedMatch) {
            title = (
                <span className={styles.approved}>
                    <FontAwesomeIcon icon={faCheckCircle} className={styles.icon} />
                    <FormattedMessage id="registration_approved" />
                </span>
            );
            houseName = approvedMatch[1];
        } else if (declinedMatch) {
            title = (
                <span className={styles.declined}>
                    <FontAwesomeIcon icon={faExclamationTriangle} className={styles.icon} />
                    <FormattedMessage id="registration_declined" />
                </span>
            );
            houseName = declinedMatch[1];
        }

        return (
            <div className={notificationClasses} onMouseEnter={this.hover} onMouseLeave={this.leave}>
                <Link className={styles.link} to={link} target={target} rel="noopener" route={route}>
                    <div className={styles.message}>
                        <div className={styles.imageContainer}>
                            <ImageWithFallback alt="Item" className={styles.image} src={imageUrl} title={title} />
                        </div>
                        <div className={styles.text}>
                            <div className={titleClassnames}>{title}</div>
                            <div className={styles['message-body']}>
                                {houseName}
                                {Boolean(houseName) && <br />}
                                {message}
                            </div>
                            <div className={timestampClasses}>
                                {newLabel}
                                <span>{timestampDisplay}</span>
                            </div>
                        </div>
                        <div className={styles['close-button']} onClick={this.markDeletedWithoutNavigation}>
                            <span>
                                <FontAwesomeIcon icon={faTimes} />
                            </span>
                        </div>
                    </div>
                    <hr />
                </Link>
            </div>
        );
    }
}
